import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { Formik } from "formik";
import API from "../../../api/api";
import { setLoading, setRole, setUpAuth } from "../../../reducer/auth/auth";
import { fetchUser, login } from "../../../services/auth";
import { setUser } from "../../../reducer/userSlice";
import { userType } from "../../../utils/utils";
import { sendVerificationCode } from "../../../services/auth";
import { getBrowserData } from "../../../utils/helpers";

import "bootstrap/dist/css/bootstrap.min.css";
import "./newclientregister.module.css";
import "./indexClient.css";

const NewClientRegister = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [emailError, setEmailError] = useState("");
  const [emailSuccess, setEmailSuccess] = useState("");
  const [typePass, SetTypePass] = useState(true);
  const [confirmtypePass, SetTypeconfirmPass] = useState(true);
  const [invalidCode, setInvalidCode] = useState("");
  const [registrationType, setRegistrationType] = useState("");
  const [mobileRegistrationStarted, setMobileRegistrationStarted] =
    useState(false);
  const [showReferralCode, setShowReferralCode] = useState(false);

  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    const urlString = window.location.href;
    let paramString = urlString.split("?")[1];
    let queryString = new URLSearchParams(paramString);

    let info = [];
    let key = [];
    for (let pair of queryString.values()) {
      info.push(pair);
    }
    for (let pair of queryString.keys()) {
      key.push(pair);
    }

    if (key[0] == "referral_code") {
      initialValues.promotion_code = info[0];
      setShowReferralCode(true);
    }
    if (info[1] !== undefined) {
      setRegistrationType(info[0]);
      localStorage.setItem("guest_id", info[1]);
    }
  }, []);

  useEffect(() => {
    document.body.classList.add("register-client-route");
    document.body.classList.toggle(
      "register-client-form-active",
      mobileRegistrationStarted
    );

    return () => {
      document.body.classList.remove("register-client-route");
      document.body.classList.remove("register-client-form-active");
    };
  }, [mobileRegistrationStarted]);

  useEffect(() => {
    if (invalidCode) {
      setShowReferralCode(true);
    }
  }, [invalidCode]);

  const changePassType = (e) => {
    SetTypePass(!typePass);
  };

  const changePassTypeConfirm = (e) => {
    SetTypeconfirmPass(!confirmtypePass);
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    if (!executeRecaptcha) {
      console.log("Recaptcha not yet available");
      return;
    }

    try {
      const token = await executeRecaptcha("register");
      const payload = {
        ...values,
        recaptcha_token: token,
      };
      RegisterUser(payload);
    } catch (error) {
      console.error("reCAPTCHA Error:", error);
    }
  };

  const RegisterUser = async (formData) => {
    setInvalidCode("");
    dispatch(setLoading(true));
    const {
      email,
      check,
      promotion_code,
      is_client_medium,
      password,
      recaptcha_token,
    } = formData;

    let item = {
      promotion_code: promotion_code,
      email: email,
      password: password,
      usertype: 3,
      is_adult: check ? 1 : 0,
      recaptcha_token: recaptcha_token,
      is_client_medium: is_client_medium ? 1 : 0,
      type: registrationType === "true" ? "guest-booking" : "",
    };

    let browserinfo = await getBrowserData();
    Object.assign(item, browserinfo);

    await API.post("register", item)
      .then((data) => {
        dispatch(setLoading(false));

        if (data.data.status) {
          LoginUser(formData);
          setEmailSuccess("");
        }
        if (!data.data.status && data.data.error.email) {
          dispatch(setLoading(false));
          setEmailSuccess("");
          setEmailError("This email address already exists in our system.");
        }
        if (
          !data.data.status &&
          data.data.error &&
          data.data.error === "Your Account is Restricted/Freezed"
        ) {
          setEmailError(
            "You are not allowed to create new accounts. Please contact support for more help."
          );
          setEmailSuccess("");
        }
        if (
          !data.data.status &&
          data.data.error &&
          data.data.error ===
            "Invalid referral code please remove and continue."
        ) {
          setInvalidCode(data.data.error);
          setEmailError("");
          setEmailSuccess("");
        }
      })
      .catch((error) => {
        dispatch(setLoading(false));
        console.log(error);
      });
  };

  const LoginUser = async (formData) => {
    dispatch(setLoading(true));
    let item = {
      email: formData.email,
      password: formData.password,
    };
    let browserinfo = await getBrowserData();
    Object.assign(item, browserinfo);

    login(item)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          localStorage.setItem("access_token", data.data.data.access_token);
          dispatch(setUpAuth());
          callProfile(data.data.data.access_token);
        }
        if (
          !data.data.status &&
          data.data.error &&
          data.data.error !== "Unauthorized"
        ) {
          setEmailError(data.data.error);
          setEmailSuccess("");
        }
        if (!data.data.status && data.data.error === "Unauthorized") {
          setEmailError("Invalid Email or Password");
          setEmailSuccess("");
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };

  const callProfile = async (token) => {
    dispatch(setLoading(true));
    await fetchUser(token)
      .then((data) => {
        dispatch(setLoading(false));
        dispatch(setUser(data.data.data));
        sendVerificationCodeHandler();
        renderUserType(data.data.data.usertype, data.data.data);
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };

  const sendVerificationCodeHandler = () => {
    let body = {
      verification_code: "",
    };

    sendVerificationCode(body)
      .then((data) => {
        if (
          !data.data.status &&
          data.data.message === "OTP sent Successfully"
        ) {
          console.log("OTP sent Successfully");
        }
      })
      .catch((data) => {
        console.log(data);
      });
  };

  const renderUserType = (type, users) => {
    const user = userType(type);
    dispatch(setRole(user));
    if (user === "medium") {
      if (users.status === 1 && users.medium_status === 1) {
        navigate("/dashboard");
      } else {
        navigate("/profile");
      }
    }
    if (user === "admin") {
      navigate("/dashboard");
    }
    if (user === "client") {
      if (users.status === 3 && users.medium_status === 0) {
        navigate("/profile");
      } else {
        navigate("/dashboard");
      }
    }
  };

  const redirectRoute = (item) => {
    navigate(item);
  };

  const handleStartRegistration = () => {
    setMobileRegistrationStarted(true);

    window.setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 80);
  };

  const handleWatchTestimonial = () => {
    setMobileRegistrationStarted(false);

    window.setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 80);
  };

  // REMOVED: openRegistrationModal function

  // SVG Icons
  const EmailIcon = () => (
    <svg
      className="input-icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 6L12 13L2 6"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const PasswordIcon = () => (
    <svg
      className="input-icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const UserIcon = () => (
    <svg
      className="input-icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const initialValues = {
    email: "",
    promotion_code: "",
    password: "",
    confirmPassword: "",
    check: false,
    is_client_medium: false,
  };

  return (
    <div
      className={`login_body register-client-page ${
        mobileRegistrationStarted ? "register-client-mobile-started" : ""
      }`}
    >
      {/* Header Section - Same as NewLogin.js */}
      <div className="header_login">
        <div className="header_container">
          <div className="header_left">
            <div className="logo">
              <img src="/images/logo-verysoul.png" alt="Very Soul Logo" />
            </div>
          </div>
          <div className="header_right">
            <span className="desktop-text">Already have an account?</span>
            <span className="mobile-text"></span>
            {/* CHANGED: onClick se modal nahi, navigate karega */}
            <button className="register-btn" onClick={() => navigate("/login")}>
              Login
            </button>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="container-fluid login_content">
        <div className="row justify-content-center login_row">
          {/* Left Area - Testimonial */}
          <div className="card_column col-md-6 text-white bg-dark-register login_left_area-img">
            <div className="card-body text-center">
              <div className="login_inner">
                <div className="mobile-register-intro">
                  <h1>Create your account</h1>
                  <p>Claim your free session with a trusted medium.</p>
                </div>

                <div className="text-center login-heading">
                  <h2 className="d-none-text d-md-block">
                    Real Connection. Real Proof.
                  </h2>
                  <h2 className="d-block d-md-none">
                    Real Connection.
                    <br />
                    Real Proof.
                  </h2>
                </div>
            
               <div className="video-container">
                    <iframe
                      src="https://player.vimeo.com/video/1174972686?h=845890efec&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1"
                      frameBorder="0"
                                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                        }}
                      title="VerySoul Video"
                    ></iframe>
                  </div>

                  <button
                    type="button"
                    className="mobile-testimonial-strip"
                    onClick={handleWatchTestimonial}
                  >
                    <div className="mobile-testimonial-thumb">
                      <span className="mobile-testimonial-play">Play</span>
                    </div>
                    <div className="mobile-testimonial-copy">
                      <strong>Watch testimonial</strong>
                      <span>Real connection. Real proof.</span>
                    </div>
                  </button>

                  <div className="mobile-trust-row">
                    <span>
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <path
                          d="M20 6L9 17L4 12"
                          stroke="currentColor"
                          strokeWidth="2.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Verified
                    </span>
                    <span>
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <path
                          d="M19 11H5C3.9 11 3 11.9 3 13V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V13C21 11.9 20.1 11 19 11Z"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M7 11V7C7 4.2 9.2 2 12 2C14.8 2 17 4.2 17 7V11"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Private
                    </span>
                    <span>
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <path
                          d="M12 3L19 6V11C19 15.5 16.1 19.7 12 21C7.9 19.7 5 15.5 5 11V6L12 3Z"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Secure
                    </span>
                  </div>

                  <button
                    type="button"
                    className="mobile-start-registration"
                    onClick={handleStartRegistration}
                  >
                    Start Registration
                  </button>

                  <p className="mobile-login-copy">
                    Already have an account? <Link to="/login">Login</Link>
                  </p>
           
              </div>
            </div>
          </div>
          {/* Right Area - Client Registration Form */}
          <div
            className={`card_column col-md-6 p-4 mb-0 login_right_area register-form-panel ${
              mobileRegistrationStarted ? "is-open" : ""
            }`}
          >
            <div className="login_inner">
              <div className="card-body">
                <h1>Client Registration</h1>
                <h3>Register to claim your free session!</h3>

                {/* Error Messages */}
                {emailError && (
                  <div className="alert alert-danger" role="alert">
                    {emailError}
                    {emailError ===
                      "This email address already exists in our system." && (
                      <>
                        <br />
                        <Link to="/login">Click here to Log in.</Link>
                      </>
                    )}
                  </div>
                )}

                {emailSuccess && (
                  <div className="alert alert-success" role="alert">
                    {emailSuccess}
                    <br />
                    <Link to="/login">Click here to Log in.</Link>
                  </div>
                )}

                <Formik
                  initialValues={initialValues}
                  enableReinitialize={true}
                  validate={(values) => {
                    const errors = {};

                    if (!values.email) {
                      errors.email = "Required";
                    } else if (
                      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                        values.email
                      )
                    ) {
                      errors.email = "Invalid email address";
                    }

                    if (!values.password) errors.password = "Required";
                    if (values.password && values.password.length < 6)
                      errors.password = "Minimum length 6 character";
                    if (
                      values.password &&
                      !/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/.test(
                        values.password
                      )
                    ) {
                      errors.password =
                        "Password must be alphanumeric with one uppercase and one special character";
                    }

                    // YEH LINE MAIN ADD KI HAI - Confirm Password Validation
                    // if (!values.confirmPassword)
                    //   errors.confirmPassword = "Required";
                    // if (values.password !== values.confirmPassword)
                    //   errors.confirmPassword = "password didn't matched";

                    if (!values.is_client_medium) {
                      errors.is_client_medium = "Required";
                    }
                    if (!values.check) {
                      errors.check = "Required";
                    }
                    return errors;
                  }}
                  onSubmit={handleSubmit}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  }) => (
                    <form className="login_form" onSubmit={handleSubmit} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }} autoComplete="off">
                      {/* Email Field */}
                      <div className="mb-4 mt-4 form-group">
                        <label>Email Address</label>
                        <div className="position-relative email-field-wrapper">
                          <div className="input-icon-wrapper">
                            <EmailIcon />
                          </div>
                          <input
                            className={`form-control ${
                              errors.email && touched.email
                                ? "error-boundry"
                                : ""
                            }`}
                            type="email"
                            name="email"
                            placeholder="myemail@address.com"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            autoComplete="off"
                          />
                        </div>
                        <div className="privacy-note mt-1">
                          We care deeply about your privacy.{" "}
                          <Link to="/privacy-policy" className="privacy-link">
                            Learn more
                          </Link>
                        </div>
                        {errors.email && touched.email && (
                          <div className="error-text">{errors.email}</div>
                        )}
                      </div>

                      {/* Password Field */}
                      <div className="mb-3 form-group">
                        <label>Create Password</label>
                        <div className="position-relative password-field-wrapper">
                          <div className="input-icon-wrapper">
                            <PasswordIcon />
                          </div>
                          <input
                            className={`form-control ${
                              errors.password && touched.password
                                ? "error-boundry"
                                : ""
                            }`}
                            type={typePass ? "password" : "text"}
                            name="password"
                            placeholder="Password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                            autoComplete="off"
                          />
                          <div
                            className="password-toggle"
                            onClick={changePassType}
                          >
                            <img
                              src={
                                typePass
                                  ? "/images/eye.png"
                                  : "/localImages/openeye.svg"
                              }
                              alt="toggle password visibility"
                              className={`eye-icon pointer ${
                                typePass ? "" : "openeye"
                              }`}
                            />
                          </div>
                        </div>
                        {errors.password && touched.password && (
                          <div className="error-text">{errors.password}</div>
                        )}
                      </div>

                      {/* <div className="mb-3 form-group">
                        <label>Confirm Password</label>
                        <div className="position-relative password-field-wrapper">
                          <div className="input-icon-wrapper">
                            <PasswordIcon />
                          </div>
                          <input
                            className={`form-control ${
                              errors.confirmPassword && touched.confirmPassword
                                ? "error-boundry"
                                : ""
                            }`}
                            type={confirmtypePass ? "password" : "text"}
                            name="confirmPassword"
                            placeholder="Confirm Password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.confirmPassword}
                          />
                          <div
                            className="password-toggle"
                            onClick={changePassTypeConfirm}
                          >
                            <img
                              src={
                                confirmtypePass
                                  ? "/images/eye.png"
                                  : "/localImages/openeye.svg"
                              }
                              alt="toggle password visibility"
                              className={`eye-icon pointer ${
                                confirmtypePass ? "" : "openeye"
                              }`}
                            />
                          </div>
                        </div>
                        {errors.confirmPassword && touched.confirmPassword && (
                          <div className="error-text">
                            {errors.confirmPassword}
                          </div>
                        )}
                      </div> */}
                      {/* Checkbox - Not a Medium */}
                      <div className="mb-3 form-group">
                        <div className="form-check">
                          <input
                            className="form-check-input checkbox-custom"
                            type="checkbox"
                            id="is_client_medium"
                            name="is_client_medium"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            checked={values.is_client_medium}
                          />
                          <label className="d-flex align-items-center flex-wrap" htmlFor="is_client_medium">
                            I am not a medium&nbsp;
                            <span className="d-block d-sm-inline" style={{ padding : "0" , color: "#212428"}}>
                              (Medium register{" "}
                              <Link className="text-underline" to="/register-medium">
                                here
                              </Link>
                              )
                            </span>
                          </label>
                        </div>
                        {errors.is_client_medium &&
                          touched.is_client_medium && (
                            <div className="error-text">
                              {errors.is_client_medium}
                            </div>
                          )}
                      </div>

                      {/* Checkbox - Over 18 */}
                      <div className="mb-3 form-group">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="check"
                            name="check"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            checked={values.check}
                          />
                          <label className="form-check-label" htmlFor="check">
                            I am over 18
                          </label>
                        </div>
                        {errors.check && touched.check && (
                          <div className="error-text">{errors.check}</div>
                        )}
                      </div>

                      {/* Referral Code Field */}
                      <div
                        className={`mb-3 form-group referral-code-group ${
                          showReferralCode ? "is-open" : ""
                        }`}
                      >
                        <button
                          type="button"
                          className="mobile-referral-toggle"
                          onClick={() => setShowReferralCode(!showReferralCode)}
                          aria-expanded={showReferralCode}
                        >
                          <span>Have a referral code?</span>
                          <span aria-hidden="true">
                            {showReferralCode ? "-" : "+"}
                          </span>
                        </button>
                        <div className="referral-field-content">
                          <label>Optional Referral Code</label>
                          <div className="position-relative email-field-wrapper">
                            <div className="input-icon-wrapper">
                              <UserIcon />
                            </div>
                            <input
                              className="form-control"
                              type="text"
                              name="promotion_code"
                              placeholder="Referral code"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.promotion_code}
                            />
                          </div>
                          <div className="referral-note mt-1">
                            Not required for free session.
                          </div>
                        </div>
                        {invalidCode && (
                          <div className="error-text">{invalidCode}</div>
                        )}
                      </div>

                      {/* Submit Button */}
                      <div className="captcha-protection-note">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                        >
                          <path
                            d="M12 3L19 6V11C19 15.5 16.1 19.7 12 21C7.9 19.7 5 15.5 5 11V6L12 3Z"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M9.5 12L11.3 13.8L15 10"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span>Protected by Captcha.</span>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <button
                            className="btn btn-primary px-4 login_button"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            Sign Up
                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>

                <p className="text-body-secondary text-center mt-3">
                  Already have an account? <Link to="/login">Login</Link>
                </p>

                <div className="text-center mt-3">
                  <a
                    href={process.env.REACT_APP_SUPPORT_URL}
                    className="contactSupport"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Contact Support
                  </a>
                </div>
              </div>

              {/* Bottom Links */}
              <div className="login_bottom_area">
                <div className="login_bottom_content">
                  <div className="login_bottom_links">
                    <ul>
                      <li>
                        <Link to="/privacy-policy" target="_blank">
                          Privacy Policy
                        </Link>
                      </li>
                      <li>
                        <Link to="/terms-conditions" target="_blank">
                          Terms & Conditions
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <p>
                    Note: For optimum performance: use Chrome, Safari, or Edge
                    browser
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* REMOVED: Registration Modal completely */}

      {/* Success Modal */}
      <div
        className="modal fade"
        id="myModal"
        role="dialog"
        style={{ display: "none" }}
      >
        <div className="modal-dialog modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body">
              <div className="icon-pop">
                <img src="/images/Union-icon.png" alt="Union-icon" />
              </div>
              <h3>
                Begin Registration to <br />
                Be a Verysoul Client
              </h3>
              <p className="mt-4">
                You have successfully created your account! To begin using this
                site you will need to activate your account via the email we
                have just sent to your address. If you do not see the email in a
                few minutes, check your "junk mail" folder or "spam" folder.
              </p>
              <div
                className="register-medium-confirnation"
                onClick={() => redirectRoute("/thank-you")}
              >
                Close
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewClientRegister;
